import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { insta, facebook, snapchat, linked } from "../../../assets/index.js";
import { Tab, Tabs, Spinner, Card } from "react-bootstrap";

const Linkedln = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const platform = "linkedln";
      setIsLoggedIn(
        platform === "instagram" ||
          platform === "facebook" ||
          platform === "snapchat" ||
          platform === "linkedln"
      );
      setLoading(false);
    }, 2000);
  }, []);

  const handleTabSelect = (eventKey) => {
    const routes = {
      instagram: "/insta",
      facebook: "/facebook",
      snapchat: "/snapchat",
      linkedin: "/linkedln",
    };
    navigate(routes[eventKey] || "/");
  };

  const statsCards = [
    {
      title: "Scheduled Posts",
      value: "24",
      icon: "calendar-date-fill",
      color: "primary",
      trend: "+12% this week",
    },
    {
      title: "Total Engagement",
      value: "1,234",
      icon: "people-fill",
      color: "success",
      trend: "+5.3% this month",
    },
    {
      title: "Posts Today",
      value: "8",
      icon: "graph-up-arrow",
      color: "warning",
      trend: "+3 from yesterday",
    },
    {
      title: "Next Scheduled",
      value: "2:30 PM",
      icon: "alarm-fill",
      color: "info",
      trend: "In 2 hours",
    },
  ];

  const socialPlatforms = [
    {
      name: "Instagram",
      icon: insta,
      gradient: "linear-gradient(45deg, #f09433, #e6683c)",
      route: "/insta",
    },
    {
      name: "Facebook",
      icon: facebook,
      gradient: "linear-gradient(45deg, #3b5998, #2b4170)",
      route: "/facebook",
    },
    {
      name: "Snapchat",
      icon: snapchat,
      gradient: "linear-gradient(45deg, #FFFC00, #FFE300)",
      route: "/snapchat",
    },
    {
      name: "LinkedIn",
      icon: linked,
      gradient: "linear-gradient(45deg, #0077B5, #00669C)",
      route: "/linkedln",
    },
  ];

  if (loading) {
    return (
      <div className="min-vh-100 d-flex justify-content-center align-items-center bg-light background-dark">
        <div className="text-center ">
          <div className="mb-3 ">
            <Spinner
              animation="border"
              variant="primary"
              style={{ width: "3rem", height: "3rem" }}
            />
          </div>
          <h5 className="">Loading your dashboard...</h5>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light py-5 background-dark ">
        <div className="container ">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <Card className="border-0 shadow-lg background-dark">
                <Card.Body className="p-5">
                  <div className="text-center mb-5">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-4 d-inline-block mb-4">
                      <i className="bi bi-shield-lock display-4 text-primary"></i>
                    </div>
                    <h2 className="mb-3 fw-bold landing-text-white">
                      Welcome to Dashboard
                    </h2>
                    <p className="text-muted landing-text-white">
                      Connect your social media accounts to get started
                    </p>
                  </div>

                  <div className="d-grid gap-3">
                    {socialPlatforms.map((platform) => (
                      <Link
                        key={platform.name}
                        to={platform.route}
                        className="text-decoration-none"
                      >
                        <div className="btn btn-light border w-100 p-3 d-flex align-items-center position-relative overflow-hidden shadow-sm hover-lift background-dark">
                          <div className="position-relative z-1 d-flex align-items-center w-100 ">
                            <img
                              src={platform.icon}
                              alt={platform.name}
                              className="rounded-circle"
                              width="32"
                              height="32"
                            />
                            <span className="ms-3 flex-grow-1 fw-semibold landing-text-white">
                              Continue with {platform.name}
                            </span>
                            <i className="bi bi-arrow-right landing-text-white"></i>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>

                  <div className="text-center mt-4 pt-3">
                    <small className="text-muted">
                      By continuing, you agree to our Terms of Service and
                      Privacy Policy
                    </small>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="container-fluid py-4">
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center ">
            <div>
              <h2 className="mb-1">Linkedln</h2>
              <p className="text-muted mb-0 landing-text-white">
                Welcome back! Here's your overview
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="sidebar1 d-lg-none d-sm-block text-center d-flex flex-row justify-content-evenly p-2 ">
        <div className="social facebook">
          <Link to="/facebook">
            <span className="col-sm-4 d-flex justify-content-center align-items-center">
              <img src={facebook} alt="Facebook" className="circle-img" />
            </span>
          </Link>
        </div>
        <div className="social instagram">
          <Link to="/insta">
            <span className="col-sm-4 d-flex justify-content-center align-items-center">
              <img src={insta} alt="Insta" className="circle-img" />
            </span>
          </Link>
        </div>
        <div className="social snapchat">
          <Link to="/snapchat">
            <span className="col-sm-4 d-flex justify-content-center align-items-center">
              <img src={snapchat} alt="Snapchat" className="circle-img" />
            </span>
          </Link>
        </div>
        <div className="social linked">
          <Link to="/linkedln">
            <span className="col-sm-4 d-flex justify-content-center align-items-center ">
              <img src={linked} alt="LinkedIn" className="circle-img" />
            </span>
          </Link>
        </div>
      </div>

      <div className="row g-4 mb-4">
        {statsCards.map((stat, index) => (
          <div key={index} className="col-12 col-sm-6 col-lg-3">
            <Card className="border-0 shadow-sm h-100 hover-lift background-dark">
              <Card.Body className="card-card-cards bg-gradient">
                <div className="d-flex justify-content-between align-items-center mb-3 ">
                  <div
                    className={`rounded-circle bg-${stat.color} bg-opacity-10 p-3`}
                  >
                    <i
                      className={`bi bi-${stat.icon} fs-4 text-${stat.color}`}
                    ></i>
                  </div>
                  <span
                    className={`badge bg-${stat.color} bg-opacity-10 text-${stat.color}`}
                  >
                    {stat.trend}
                  </span>
                </div>
                <h6 className="text-muted mb-2 landing-text-white">
                  {stat.title}
                </h6>
                <h3 className="mb-0 landing-text-white">{stat.value}</h3>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
      <Card className="border-0 shadow-sm background-dark">
        <Card.Body>
          <Tabs
            defaultActiveKey="instagram"
            onSelect={handleTabSelect}
            className="mb-4 border-0 d-none d-lg-block d-lg-flex"
          >
            {socialPlatforms.map((platform) => (
              <Tab
                key={platform.name.toLowerCase()}
                eventKey={platform.name.toLowerCase()}
                title={
                  <div className="d-flex align-items-center">
                    <img
                      src={platform.icon}
                      alt={platform.name}
                      width="20"
                      height="20"
                      className="me-2"
                    />
                    {platform.name}
                  </div>
                }
              />
            ))}
          </Tabs>
          <div className="card p-4 shadow border-0 rounded-lg mb-5 bg-light background-dark">
            <h3 className="h5 font-weight-bold mb-4 text-dark landing-text-white ">
              Upcoming Posts
            </h3>
            <div className="list-group">
              {[
                {
                  title: "Post Title 1",
                  platform: "Instagram",
                  time: "2:30 PM",
                },
                {
                  title: "Post Title 2",
                  platform: "Facebook",
                  time: "4:00 PM",
                },
                {
                  title: "Post Title 3",
                  platform: "Snapchat",
                  time: "5:15 PM",
                },
              ].map((item, index) => {
                let badgeColor;
                switch (item.platform) {
                  case "Instagram":
                    badgeColor = "bg-danger";
                    break;
                  case "Facebook":
                    badgeColor = "bg-info";
                    break;
                  case "Snapchat":
                    badgeColor = "bg-warning";
                    break;
                  case "linkedln":
                    badgeColor = "bg-info";
                    break;
                  default:
                    badgeColor = "bg-light";
                }

                return (
                  <div
                    key={index}
                    className="list-group-item rounded d-flex justify-content-between align-items-center p-4 bg-light rounded-lg mb-3 shadow-sm background-dark"
                  >
                    <div className="d-flex align-items-center gap-4">
                      <div className="w-50 profile-upcoming"></div>
                      <div>
                        <h5 className="font-weight-semibold text-dark landing-text-white">
                          {item.title}
                        </h5>
                        <p className="text-muted fs-6 landing-text-white">
                          Scheduled for {item.time}
                        </p>
                      </div>
                    </div>
                    <span className={`badge ${badgeColor} text-dark`}>
                      {item.platform}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row g-4">
            <div className="col-sm-12 col-md-6 mb-4">
              <div className="card p-4 shadow border-0 rounded-lg text-dark background-dark">
                <h3 className="h5 font-weight-bold mb-4 landing-text-white">
                  Quick Actions
                </h3>
                <div className="list-group mb-3 ">
                  {["Create New Post", "View Analytics", "Manage Queue"].map(
                    (action, index) => (
                      <button
                        key={index}
                        className="list-group-item list-group-item-action p-2 text-left rounded-lg bg-light text-dark background-dark landing-text-white"
                      >
                        {action}
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 mb-5 activity-recent">
              <div className="card p-4 shadow border-0 rounded-lg  background-dark">
                <h3 className="activity-recent-text  mb-4 text-dark landing-text-white">
                  Recent Activity
                </h3>
                <div className="list-group">
                  {[1, 2].map((item) => (
                    <div
                      key={item}
                      className="list-group-item d-flex align-items-center gap-4 p-3 bg-white shadow-sm background-dark "
                    >
                      <div className="rounded-5 color-success"></div>
                      <p className=" mb-0 text-dark fs-6 landing-text-white">
                        Post successfully published to Instagram
                      </p>
                      <span className="text-muted small landing-text-white">
                        2h ago
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      <style>
        {`
          .hover-lift {
            transform: translateY(0);
            transition: all 0.2s ease;
          }
          .hover-lift:hover {
            transform: translateY(-3px);
            box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.08) !important;
          }
          .z-1 {
            z-index: 1;
          }
        `}
      </style>
    </div>
  );
};

export default Linkedln;
